<template>
  <div class="container">
    <el-row style="padding-left: 100px; padding-right: 100px">
      <el-col :span="4">
        <div class="logo-div">
          <img
            class="logo-img"
            src="../assets/images/icon_logo.png"
            :style="{ width: '80px', height: '80x' }"
            alt="example"
          />
          <p class="logo_text">
            <img
              src="../assets/images/logo_text.png"
              :style="{ width: '233px', height: '30px' }"
              alt="example"
            />
          </p>
        </div>
      </el-col>
      <el-col :span="20">
        <div class="title-div">
          <div class="title-service" @click="goServicet">Terms of service</div>
          <div class="title-policy" @click="goPolicy">Privacy Policy</div>
          <div class="title-home">HOME</div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="div-introduce">
        <div>
          <div style="width: 700px">
            Break Barriers, Engage in Interactive Chats, and Make Friends.
          </div>
        </div>
        <div class="div-introduce-app">
          Come And Download Our <span>App</span>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="div-download">
          <!-- <div class="div-apple" @click="downloadIos">
            <div class="icon-apple"></div>

            <p class="p-apple">Apple Download</p>
          </div> -->
          <div class="div-android" @click="downloadAndroid">
            <div class="icon-android"></div>
            <p class="p-android">Android Download</p>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="div-contact">Contact Email: {{ appEmail }}</div>
  </div>
</template>

<script>
export default {
  methods: {
    goServicet() {
      this.$router.push("/usersAgreement");
    },
    goPolicy() {
      this.$router.push("/privacyAgreement");
    },
    downloadAndroid() {
      window.location.href = `https://play.google.com/store/apps/details?id=com.tomo.chat.vie`;
    },
    downloadIos() {
      window.location.href = `https://apps.apple.com/cn/app/id6458732985`;
    },
  },
};
</script>

<style scoped>
@import "../assets/style/style.css";
</style>
<style>
.logo-div {
  margin-top: 80px;
  padding-right: 50px;
  display: flex;
  align-items: center;
}
.logo-img {
  display: block;
  font-size: 50px;
  margin-left: 18px; /* 给图片和文本之间添加一点间距 */
  margin-right: 18px;
}
.title-div {
  margin-top: 27px;
  float: right;
  padding: 10px;
  cursor: pointer;
}
.title-home,
.title-policy,
.title-service {
  padding: 11px 29px;
  float: right;
  margin-left: 10px;
  font-weight: 500;
  font-size: 30px;
  color: #ffffff;
}
.title-home:hover {
  background: #e7ab79;
  color: #000;
  box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.2);
  border-radius: 58px 58px 58px 58px;
}
.title-policy:hover {
  background: #e7ab79;
  color: #000;
  box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.2);
  border-radius: 58px 58px 58px 58px;
}
.title-service:hover {
  background: #e7ab79;
  color: #000;
  box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.2);
  border-radius: 58px 58px 58px 58px;
}
.div-introduce {
  margin-top: 5%;
  padding-left: 100px;
  padding-bottom: 1.8%;
  width: 1000px;

  font-family: Inter, Inter;
  font-weight: 500;
  font-size: 36px;
  color: #fff7d8;
  line-height: 60px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.div-introduce-app {
  color: #fff;
  font-size: 36px;
}
.div-introduce-app span {
  font-size: 48px;
  font-weight: 600;
  color: #e7ab79;
}
.div-app {
  margin-bottom: 152px;
  cursor: pointer;
  padding-left: 150px;
  font-family: Inter, Inter;
  font-weight: normal;
  font-size: 30px;
  color: #ffffff;
  line-height: 60px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.sp-app {
  font-size: 50px;
  color: #ffc850;
}
.div-download {
  padding-left: 140px;
  display: flex;
  align-items: center;
}
.div-apple {
  padding: 11px 34px;
  text-align: center;
  border-radius: 58px 58px 58px 58px;

  display: flex;
  align-items: center;
  cursor: pointer;
  background: url("../assets/images/bg_apple.png") no-repeat center/contain;
  color: #333;
}

.div-apple .icon-apple {
  width: 50px;
  height: 50px;
  background: url("../assets/images/icon_apple_hover.png") no-repeat
    center/contain;
}
.div-apple:hover {
  /* background: #ffc011; */
  background: url("../assets/images/bg_apple_check.png") no-repeat
    center/contain;
}
.div-apple:hover .p-apple {
  color: #fff;
}
.div-apple:hover .icon-apple {
  color: #fff;
  background: url("../assets/images/icon_apple.png") no-repeat center/contain;
}
.div-android {
  position: relative;
  z-index: 3;
  margin-top: 10px;
  /* margin-left: 50px; */
  padding-left: 34px;
  padding-right: 34px;
  height: 77px;
  text-align: center;
  border-radius: 58px 58px 58px 58px;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.5);
  /* background: url("../assets/images/bg_apple.png") no-repeat center/contain; */
  color: #333;
  cursor: pointer;
}
.div-android .icon-android {
  width: 50px;
  height: 50px;
  background: url("../assets/images/icon_android.png") no-repeat center/contain;
}
.div-android:hover {
  background: url("../assets/images/android.png") no-repeat center/cover;
}
.div-android:hover .p-android {
  color: #fff;
}
.div-android:hover .icon-android {
  color: #fff;
  background: url("../assets/images/icon_android.png") no-repeat center/contain;
}
.p-apple,
.p-android {
  margin-left: 5px;
  font-family: Inter, Inter;
  font-weight: 500;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.5);

  text-align: left;
  font-style: normal;
  text-transform: none;
}
.div-contact {
  z-index: 0;
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 127px;
  background: rgba(0, 0, 0, 0.19);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter, Inter;
  font-weight: 500;
  font-size: 30px;
  color: #fff;
  line-height: 35px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.container {
  position: relative;
  width: 100%;
  height: 100%;
  /* position: relative; */
  background-image: url("../assets/images/foodiesbox_home.png");
  background-size: 100% 100%;
}
.logo_text {
  margin-top: -10px;
  width: 274px;
  height: 85px;
  font-family: Inter, Inter;
  font-weight: 500;
  font-size: 50px;
  color: #ffffff;
  line-height: 82px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.ios img {
  width: 51px;
  height: 62px;
  position: absolute;
  left: 114px;
  top: 21px;
}
.ios p {
  width: 240px;
  height: 28px;
  font-size: 26px;
  color: #00dcdc;
  position: absolute;
  left: 187px;
  top: 39px;
}
.anzhuo p {
  color: #00dcdc;
}
ul {
  position: absolute;
  right: 0px;
  top: 52px;
}
li {
  font-size: 26px;
  color: #fff;
  display: inline-block;
  margin-right: 46px;
}
li img {
  width: 24px;
  height: 24px;
}
</style>
